/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The CheckPhoneNumForm model module.
   * @module token/model/CheckPhoneNumForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CheckPhoneNumForm</code>.
   * @alias module:token/model/CheckPhoneNumForm
   * @class
   * @param phoneNum {String} 手机号
   */
  var exports = function(phoneNum) {
    var _this = this;

    _this['phoneNum'] = phoneNum;
  };

  /**
   * Constructs a <code>CheckPhoneNumForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/CheckPhoneNumForm} obj Optional instance to populate.
   * @return {module:token/model/CheckPhoneNumForm} The populated <code>CheckPhoneNumForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
    }
    return obj;
  }

  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;



  export default exports;
;


